// import $ from 'jquery'
import angular from 'angular';
import angularRoute from 'angular-route'
import angularResource from 'angular-resource'
import angularGeolocation from 'angularjs-geolocation'
import angularTranslate from 'angular-translate'
import 'angular-translate-loader-url'
import Cookies from 'js-cookie'
import angularStripe from 'angular-stripe'
import routes from './routes'
import 'angular-sanitize'

import recaptcha from 'angular-recaptcha'

import Controllers from './controllers';
import Factories from './factories';
import { escape } from 'querystring';


if (location.hostname.toLowerCase() == "thelottofactorysite.azurewebsites.net"
        || location.hostname.toLowerCase() == "core.thelottofactory.com") {
    document.location = '//www.thelottofactory.com';
}


// create the module and name it TLFApp
var TLFApp = angular.module('TLFApp', ['ngRoute', 'ngResource', 'geolocation', 'vcRecaptcha', 'pascalprecht.translate', 'angular-stripe', Controllers.name, Factories.name, 'ngSanitize']);

//TLFApp.config(function (stripeProvider) {
//	stripeProvider.setPublishableKey('pk_test_PBAQXzTasABh6Rrou4GUnpUY');
//});
angular
  .module('exceptionOverride', [])
  .factory('$exceptionHandler', function() {
    return function(exception, cause) {
      rg4js('send', { error: exception, customData: { cause: cause }, tags: ['Angular'] });
    };
  });




TLFApp.directive('a', function () {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            if (attrs.href === '#') {
                elem.on('click', function (e) {
                    e.preventDefault();
                });
            }
        }
    };
});

TLFApp.filter('number_with_spaces', function () {
	return function (input) {
		return Math.round(input).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}
});


TLFApp.filter('myCurrency', ['$filter', function ($filter) {
  return function (input, lang, currency) {
    var currencySymbol = '\u0024'; //$
    if (currency == null) {
      currency = 'CAD';
    }
    switch (currency) {
      case 'CAD':
      case 'USD':
        currencySymbol = '\u0024';
        break;
      case 'GBP':
        currencySymbol = '\u00A3'; //�
        break;
      default:
        currencySymbol = '\u0024';
    }
    if (typeof input == 'string' || input instanceof String) {
      input = input.replace(",", "")
    }

    if (lang === 'en' || lang === 'es') {
      input = parseFloat(input);
      input = input.toFixed(input % 1 === 0 ? 0 : 2);
      return currencySymbol + input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else if (lang === 'fr') {
      input = parseFloat(input);
      input = input.toFixed(input % 1 === 0 ? 0 : 2);
      input = input.toString().replace('.', ',');
      return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + currencySymbol;
    } else {
      input = parseFloat(input);
      input = input.toFixed(input % 1 === 0 ? 0 : 2);
      return currencySymbol + input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };
}]);

//Day and month: 16 May/16 mai
//*French months are not supposed to be capitalized*
TLFApp.filter('datedMMM', ['$filter', function ($filter) {
  return function (input, lang) {
    if (lang === 'en') {
      var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();

      return day + ' ' + monthNames[monthIndex];
    } else if (lang === 'fr') {
      var monthNames = [
        "jan", "f\u00E9v", "mar",
        "avr", "mai", "jun", "jul",
        "ao\u00FB", "sep", "oct",
        "nov", "d\u00E9c"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();

      return day + ' ' + monthNames[monthIndex];
    } else if (lang === 'es') {
        var monthNames = [
            "enero", "feb", "mar",
            "abr", "mayo", "jun", "jul",
            "agosto", "sept", "oct",
            "nov", "dic"
        ];

        var date = new Date(input);
        var day = date.getDate();
        var monthIndex = date.getMonth();

        return day + ' ' + monthNames[monthIndex];
    } else {
      var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();

      return day + ' ' + monthNames[monthIndex];
    }
  };
}]);

//Returns the day of the week: Friday/vendredi
//*French days are not supposed to be capitalized*
TLFApp.filter('dateEEEE', ['$filter', function ($filter) {
  return function (input, lang) {
    if (lang === 'en') {
      var weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";

      var date = new Date(input);
      var day = date.getDay();

      return weekday[day];
    } else if (lang === 'fr') {
      var weekday = new Array(7);
      weekday[0] = "dimanche";
      weekday[1] = "lundi";
      weekday[2] = "mardi";
      weekday[3] = "mercredi";
      weekday[4] = "jeudi";
      weekday[5] = "vendredi";
      weekday[6] = "samedi";

      var date = new Date(input);
      var day = date.getDay();

      return weekday[day];
    } else if (lang === 'es') {
        var weekday = new Array(7);
        weekday[0] = "domingo";
        weekday[1] = "lunes";
        weekday[2] = "martes";
        weekday[3] = "miércoles";
        weekday[4] = "jueves";
        weekday[5] = "viernes";
        weekday[6] = "sábado";

        var date = new Date(input);
        var day = date.getDay();

        return weekday[day];
    } else {
        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        var date = new Date(input);
        var day = date.getDay();

        return weekday[day];
    }
  };
}]);

//Formated dates with full words
//June 7th, 2019
//7 juin 2019
//*French months are not supposed to be capitalized*
//Please resist the urge to change them to capitals, I know its hard. Its hard for me too.
TLFApp.filter('myDate', ['$filter', function ($filter) {
  return function (input, lang, dayFormat) {
    if (lang === 'en') {
      var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear()

      if (dayFormat === 'dd' && day < 10) {
        return monthNames[monthIndex] + ' 0' + day + ', ' + year;
      } else {
        return monthNames[monthIndex] + ' ' + day + ', ' + year;
      }
    } else if (lang === 'fr') {
      var monthNames = [
        "janvier", "f\u00E9vrier", "mars",
        "avril", "mai", "juin", "juillet",
        "ao\u00FBt", "septembre", "octobre",
        "novembre", "d\u00E9cembre"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear()

      if (dayFormat === 'dd' && day < 10) {
        return '0' + day + ' ' + monthNames[monthIndex] + ' ' + year;
      } else {
        return day + ' ' + monthNames[monthIndex] + ' ' + year;
      }
    } else if (lang === 'es') {
      var monthNames = [
        "enero", "febrero", "marzo",
        "abril", "mayo", "junio", "julio",
        "agosto", "septiembre", "octubre",
        "noviembre", "deciembre"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear()

      if (dayFormat === 'dd' && day < 10) {
        return '0' + day + ' ' + monthNames[monthIndex] + ' ' + year;
      } else {
        return day + ' ' + monthNames[monthIndex] + ' ' + year;
      }
    } else {
      var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
      ];

      var date = new Date(input);
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear()

      if (dayFormat === 'dd' && day < 10) {
        return monthNames[monthIndex] + ' 0' + day + ', ' + year;
      } else {
        return monthNames[monthIndex] + ' ' + day + ', ' + year;
      }
    }
  }
}]);

//Time from date
TLFApp.filter('myTime', function () {
    return function (input) {
        var date = new Date(input);

        var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
        var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()

        return hour + ":" + minutes
    }
});

//Dates such as 15-06-2019 or 06-15-2019
TLFApp.filter('dateddmmyyyy', ['$filter', function ($filter) {
  return function (input, lang) {
    if (lang === 'en' || lang === 'es') {
      var date = new Date(input);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear()

      if (day < 10 && month < 10)
        return '0' + month + '-0' + day + '-' + year;
      else if (day < 10)
        return month + '-0' + day + '-' + year;
      else if (month < 10)
        return '0' + month + '-' + day + '-' + year;
      else
        return month + '-' + day + '-' + year;
    } else if (lang === 'fr') {
      var date = new Date(input);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear()

      if (day < 10 && month < 10)
        return '0' + day + '-0' + month + '-' + year;
      else if (day < 10)
        return '0' + day + '-' + month + '-' + year;
      else if (month < 10)
        return day + '-0' + month + '-' + year;
      else
        return day + '-' + month + '-' + year;
    } else {
      var date = new Date(input);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear()

      if (day < 10 && month < 10)
        return '0' + month + '-0' + day + '-' + year;
      else if (day < 10)
        return month + '-0' + day + '-' + year;
      else if (month < 10)
        return '0' + month + '-' + day + '-' + year;
      else
        return month + '-' + day + '-' + year;
    }
  }
}]);

/*
* For building share text.
* Share text takes in too many angular variables to efficiently store it in the db, especially not under a repeat.
* Instead I combined a lengthy filter call, with hardcoded language text.
* Below is how the filter call looks. Notice there is a chained filter call to 'mydate' first.
* {{i.Date | myDate: SelectedLanguage | share: SelectedLanguage:i.Name:i.Amount:i.Status:SiteDetails.Currency}}
* The end result should look similar to the following
* Player Name was a $XXX (NON)WINNER on date
* Matthew Dunphy �tait un GAGNANT de 165,00 $ le 15 f�vrier 2019
*/
TLFApp.filter('share', ['$filter', function ($filter) {
  return function (date, lang, name, amount, status, currency) {
    var currencySymbol = '\u0024'; //$
      if (status === 'winner' && lang === 'fr') {
          status = 'GAGNANT';
      } else if (lang === 'fr') {
          status = 'NON-GAGNANT';
      } else if (lang === 'es' && status === 'winner') {
          status = 'GANADOR';
      } else if (lang === 'es') {
          status = 'NO GANADOR';
      }

    if (currency == null) {
      currency = 'CAD';
    }
    switch (currency) {
      case 'CAD':
      case 'USD':
        currencySymbol = '\u0024';
        break;
      case 'GBP':
        currencySymbol = '\u00A3';
        break;
      default:
        currencySymbol = '\u0024';
    }
    if (amount === null) {
      amount = 0;
    }
    if (lang === 'en') {
      var returnValue = "";
      returnValue += name + " ";
      returnValue += "was a ";
      returnValue += currencySymbol + amount + " ";
      returnValue += status.toUpperCase() + " ";
      returnValue += "on ";
      returnValue += date;
      return returnValue;
    } else if (lang === 'fr') {
      var returnValue = "";
      returnValue += name + " ";
      returnValue += "\u00E9tait un ";
      returnValue += status.toUpperCase() + " de ";
      amount = amount.toString().replace('.', ',');
      returnValue += amount + currencySymbol + " ";
      returnValue += "le ";
      returnValue += date;
      return returnValue;
    } else if (lang === 'es') {
      var returnValue = "";
      returnValue += name + " ";
      returnValue += "fue una ";
      returnValue += status.toUpperCase() + " de ";
      returnValue += currencySymbol + amount + " ";
      returnValue += "el ";
      returnValue += date;
      return returnValue;
    } else {
      var returnValue = "";
      returnValue += name + " ";
      returnValue += "was a ";
      returnValue += currencySymbol + amount + " ";
      returnValue += status.toUpperCase() + " ";
      returnValue += "on ";
      returnValue += date;
      return returnValue;
    }
  }
}]);

/*
 * Filter for Payment types.
 * Payment types are stored in the CartTransaction and the vwTransactionDetails tables.
 * The IF statements in the filter must be maintained with the standard at which we store our payment types.
 * No conditions are needed for English since we are already storing the Payment Types in English.
 */
TLFApp.filter('paymentType', ['$filter', function ($filter) {
  return function (input, lang) {
    if (lang === 'en') {
      return input;
    } else if (lang === 'fr') {
      if (input == "Credit Card") {
        return "Carte de cr\u00E9dit";
      } else if (input == "Cash") {
        return "Comptant";
      } else {
        return input;
      }
    } else if (lang === 'es') {
        if (input == "Credit Card") {
            return "Tarjeta de cr\u00E9dito";
        } else if (input == "Cash") {
            return "Efectivo";
        } else {
            return input;
        }
    } else {
      return input;
    }
  }
}]);

TLFApp.config(['$sceDelegateProvider', function ($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from outer templates domain.
      TFL_Core_Template_Location + '**'
    ]);
}]);

TLFApp.config(['$sceProvider', function ($sceProvider) {
    $sceProvider.enabled(false);
}]);

//Setup Translation stuff
TLFApp.config(function ($translateProvider) {
  'ngInject';

	//$translateProvider.useUrlLoader('/src/i18n/locale-en.json?OrganizationId=' + TFL_ID);

	//Dynamic Tags
	$translateProvider.useUrlLoader(TFL_Base_Url + 'organization/content?OrganizationId=' + TFL_ID);

    //Default dynamic tags
    //$translateProvider.useUrlLoader(TFL_Base_Url + 'organization/content?OrganizationId=DEFAULT');

	//Default Language
  $translateProvider.preferredLanguage("English");
});



// configure our routes
TLFApp.config(['$locationProvider', '$routeProvider', function ($locationProvider, $routeProvider) {

    //this loads up our routes dynamically
    for (var path in routes) {
        $routeProvider.when(path, routes[path]);
    }

    $routeProvider.otherwise({ redirectTo: '/' });

    // use the HTML5 History API
    $locationProvider.html5Mode(true);

}]);

// Add our Interceptor
TLFApp.config(['$httpProvider', function($httpProvider){
  $httpProvider.interceptors.push("HttpErrorInterceptorModule");
}]);

//Check for api key in the URL and place it in the cookie.
//Add a header param for that cookie to auth.
TLFApp.run(['$http', '$location', function ($http, $location) {
    jQuery(document).ready(function ($) {
        var AuthToken = $location.search().ApiKey;
        if (AuthToken !== undefined) {
            var date = new Date();
            var minutes = 60000;
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            Cookies.set('TLF_Auth_Token', AuthToken, { expires: date });
            $http.defaults.headers.common['Auth_Token'] = Cookies.get('TLF_Auth_Token');
        }
        var MemberId = $location.search().MemberId;
        if (MemberId !== undefined) {
            var date = new Date();
            var minutes = 60000;
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            Cookies.set('Member_Id', MemberId, { expires: date });
            $http.defaults.headers.common['Member_Id'] = Cookies.get('Member_Id');
        }
        var Email = $location.search().Email;
        if (Email !== undefined) {
            Email = encodeURIComponent($location.search().Email)
            var date = new Date();
            var minutes = 60000;
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            Cookies.set('Email', Email, { expires: date });
            $http.defaults.headers.common['Email'] = Cookies.get('Email');
        }
    });
}]);

TLFApp.filter('formatTimer', function () {
    return function (input) {
        var millseconds = input * 1000;
        var seconds = Math.floor(millseconds / 1000);
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor((seconds % 86400) / 3600);
        var minutes = Math.floor(((seconds % 86400) % 3600) / 60);
        var timeString = '';
        if(days > 0) timeString += (days > 1) ? (days + " Days ") : (days + " Day ");
        if(hours > 0) timeString += (hours > 1) ? (hours + " Hours ") : (hours + " Hour ");
        if(minutes >= 0) timeString += (minutes > 1) ? (minutes + " Minutes ") : (minutes + " Minute ");
        return timeString;
    }
});

TLFApp.filter('formatTimerShort', function () {
    return function (input) {
        var millseconds = input * 1000;
        var seconds = Math.floor(millseconds / 1000);
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor((seconds % 86400) / 3600);
        var minutes = Math.floor(((seconds % 86400) % 3600) / 60);
        var timeString = '';
        if (days > 0)
        {
            if (hours > 0)
            {
                days++;
            }
            timeString = (days > 1) ? (days + " DAYS ") : (days + " DAY ");
            return timeString;
        }
        if (hours > 0)
        {
            if (minutes > 0)
            {
                hours++;
            }
            timeString = (hours > 1) ? (hours + " HRS ") : (hours + " HR ");
            return timeString;
        }
        if (minutes >= 0)
        {
            timeString = (minutes > 1) ? (minutes + " MINS ") : (minutes + " MIN ");
            return timeString;
        }
    }
});

//Catch Errors (Cookie expired or error)
TLFApp.factory("HttpErrorInterceptorModule", ["$q", "$rootScope", "$location",
    function ($q, $rootScope, $location) {
        var success = function (response) {
            // pass through
            return response;
        },
            error = function (response) {
                if (response.status === 401) {

                    $location.path('/connect').replace();
                }
                else if (response.status === 500) {
                    $location.path('/error').replace();
                }
                return $q.reject(response);
            };

        return function (httpPromise) {
            return httpPromise.then(success, error);
        };
    }
]);

TLFApp.controller('appController', function ($rootScope,  $locatione) {
  $rootScope.$on('$routeChangeSuccess', function() {
    gtag('config', GA_Tag, {'page_path': $location.path()});
    rg4js('trackEvent', {
      type: 'pageView',
      path: '/' + $rootScope.area
    });
  });
});

TLFApp.directive('myEnter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.myEnter);
                });

                event.preventDefault();
            }
        });
    };
});

TLFApp.directive('loadSlideShowThreateningGrizzly', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('#slideshow').flexslider();
        }
    };
});

TLFApp.directive('loadSlideShowRonBurgundy', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('.hero-slider').flexslider({
                animation: 'slide',
                directionNav: false
            });
        }
    };
});

TLFApp.directive('loadSlideShowBlueCleric', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('#slideshow').flexslider({
                animation: 'slide',
                directionNav: false
            });
        }
    };
});

TLFApp.directive('loadSlideShowBody', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('#body-slider').flexslider({
                animation: 'slide'
            });
        }
    };
});

TLFApp.directive('loadSlideShowBanner', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('#banner-slider').flexslider({
                animation: 'fade',
                directionNav: false,
                controlNav: false,
                slideshowSpeed: 5000
            });
        }
    };
});

TLFApp.directive('loadSlideShowImages', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('#image-slider').flexslider({
              animation: 'slide',
              animationLoop: false,
              itemWidth: 334,
              itemMargin: 6,
              minItems: 1,
              maxItems: 1
            });
        }
    };
});

TLFApp.directive('loadStepSlider', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            jQuery('.steps.mobile').flexslider({
              animation: 'slide',
              slideshow: false,
              directionNav: false,
              itemWidth: 310,
              itemMargin: 13,
              minItems: 1,
              maxItems: 1
            });
        }
    };
});

TLFApp.config(function (vcRecaptchaServiceProvider) {
    vcRecaptchaServiceProvider.setSiteKey(Recaptcha_Key)
});